export default "__VITE_ASSET__CELY_Mfa__"